import type { OptionsMenuProps } from "app/pages/sales-intelligence/common-components/options-menu/OptionsMenu/OptionsMenu";
import type { MenuItemOption } from "app/pages/sales-intelligence/common-components/options-menu/types";
import type { ComponentType } from "react";
import trackingService from "../../services/tracking/trackingService";

type ExpectedProps = Partial<Pick<OptionsMenuProps, "onSelect">>;

/**
 * This HoC encapsulates tracking for the list options component
 * @param ListOptionsComponent
 * @returns
 */
export default function withListOptionsTracking<P extends ExpectedProps>(ListOptionsComponent: ComponentType<P>) {
    return function WrappedWithListOptionsTracking(props: P) {
        function handleOptionClick(option: MenuItemOption): void {
            trackingService.trackListOptionsClicked();
            props.onSelect?.(option);
        }

        return (
            <ListOptionsComponent
                {...props}
                onSelect={handleOptionClick}
            />
        );
    };
}
